/*!
 * Description: this file contains the main base component for
 *  the rendering of the section "exercise"
 * Components: GuideSectionManager, Guide
 */
import React from "react";
import Card from "components/Card/Card.jsx";

import CardBody from "components/Card/CardBody.jsx";
import Container from "@mui/material/Container";
import Collapse from "@mui/material/Collapse";
//Styles
import withStyles from "@mui/styles/withStyles";
import { exerciseStyle } from "assets/jss/incept-sustainability-variables.jsx";
 
//All exercises types you can import
import QA from "components/Exercise/QA.js";
import QAWithQuote from "components/Exercise/QAWithQuote.js";
import DragAndDrop from "components/Exercise/DragAndDrop.js";
import DragAndDropRanking from "components/Exercise/DragAndDropRanking.js";
import DragAndDropTwoList from "components/Exercise/DragAndDropTwoList.js";
import DragAndDropMultiple from "components/Exercise/DragAndDropMultiple.jsx";
import DragAndDropTwoListGrouped from "components/Exercise/DragAndDropTwoListGrouped.js";
import DragAndDropQAPair from "components/Exercise/DragAndDropQAPair.js";
import SimpleChoice from "components/Exercise/SimpleChoice.js";
import SimpleChoiceImage from "components/Exercise/SimpleChoiceImage.js";
import SimpleChoiceGroupedText from "components/Exercise/SimpleChoiceGroupedText.js";
import SimpleChoiceSelectionInfo from "components/Exercise/SimpleChoiceSelectionInfo.js";
import MultiChoice from "components/Exercise/MultiChoice.js";
import LikertScale2 from "components/Exercise/LikertScale.js";
import MultiChoiceGroupedText from "components/Exercise/MultiChoiceGroupedText.js";
import MultiChoiceTextBox from "components/Exercise/MultiChoiceTextBox.js";
import Timeline from "components/Exercise/Timeline.js";
import ImageHover from "components/Exercise/ImageHover.js";
import SelfWriting from "components/Exercise/SelfWriting.js";
import DropDownWithImage from "components/Exercise/DropDownWithImage.js";
import DropDownWithText from "components/Exercise/DropDownWithText.js";
import DropDownGroups from "components/Exercise/DropDownGroups.js";
import LifeCycle from "components/Exercise/LifeCycle.js";
import LifeCycleExtension from "components/Exercise/LifeCycleExtension.js";
import ExtraSDG from "components/Exercise/ExtraSDG.js";
import WithoutOne from "components/Exercise/WithoutOne.js";
import arrowdown from 'assets/img/down-arrow.svg';
import checkmark from 'assets/img/checkmark.png';
// import { Button } from "@storybook/react/demo";
import GridItem from 'components/Grid/GridItem';
import GridContainer from 'components/Grid/GridContainer';
import { ourLightGreen } from "assets/jss/incept-sustainability-variables.jsx";
import { GuideCardTitle } from "components/GuidePage/GuideStyleCommon.js";
import activitynodataicon from 'assets/img/activitynodataicon.svg';
import activity from 'assets/img/activity.svg';
import greyActivity from 'assets/img/activity-grey.svg';
import { useMediaQuery } from 'react-responsive';
import { LifeCycleContext } from "./LifeCycleProvider";

//Translations
import { withTranslation } from 'react-i18next';
 
const styles = {
  root: {},
  cardExercise: {
    backgroundColor: ourLightGreen,
    marginBottom: "10px",
    minHeight: "110px",
		marginTop: "0"
  },
  cardHeader: {
    fontSize: exerciseStyle.title.fontSize,
  },
  cardHeaderTitle: {
    fontSize: exerciseStyle.title.fontSize,
    marginTop: "10px",
    fontWeight: "bold",
  },
  cardBody: {
    /*paddingTop: "30px",
    paddingLeft: "70px",
    paddingRight: "70px",*/
  },
  iconNavBack: {
    fontSize: "30px",
  },
  checkmark: {
	"@media only screen and (max-width: 960px)": {
		float: "right",
	},
  },
  buttonAnswer: {
    color: "#fff",
    borderRadius: "3rem",
    textTransform: "none",
    backgroundColor: "#ff6f69",
    width: "100px",
    height: "25px",
    padding: "0px 8px !important",
    "&:hover, &:active, &:focus,": {
      filter: "brightness(100%)",
      backgroundColor: "#ff6f69",
    },
  },
  container: {
		"@media only screen and (max-width: 960px)": {
			padding: "0",
		}
	},
	iconDownArrow: {
		cursor: "pointer",
	},
	iconDownArrowDiv: {
		paddingTop: "20px",
		textAlign: "center",
	}
};

function withMyHook(Component) {
  return function WrappedComponent(props) {
    const mobile = useMediaQuery({ query: `(max-width: 1200px)` });
    return <Component {...props} isMobile={mobile} />;
  }
}

 
/*
 * Description: this component renders an exercise, it looks the
 *    type of exercise and imports the corresponding component
 */
class GuideExercise extends React.Component {

	constructor(props){
		super(props);
		this.state = {
			scrollsection: true,
		}
	}

	componentDidUpdate(prevProps, prevState) {
		//To avoid infinite loop, we ignore passing from "loading:true" to "loading:false" only
		if (prevState.stepn!==this.state.stepn) {
			this.setState({scrollsection: false});
		}

		/*useEffect(() => {
			this.itemsRef.current = this.itemsRef.current.slice(0, 20);
		 });*/

		//Now it won't save exercises when changing step, submit button will do that
		/*const locationChanged = this.props.location !== prevProps.location;
		if (locationChanged)
			this._updateresults(false, false, 0);*/
		//this.refs.child.savecomponentresult();
	};

	/*componentDidMount() {
		this.setState({scrollsection: false});
	}*/

  /*
   * Looks the type of exercise and imports the corresponding component
   *
   * The props passed in each component (exercise, save2, inkey, datasav2)
   * are used for saving the data of the exercises
   */
  _renderExerciseType(exercise, saveresloc, indexkey, datasav, alldata, id) {
    const { type, subtype } = exercise;
    
    switch (type) {
      case "qa":
        switch (subtype) {
          case "with-quote":
            return (
              <QAWithQuote
                key={id}
                ref="child"
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          default:
            return (
              <QA
                key={id}
                exercise={exercise}
                save2={saveresloc}
                exercise_id={id}
                inkey={indexkey}
                datasav2={datasav !== "undefined" ? datasav:""}
              />
            );
        }
      case "dragdrop":
        switch (subtype) {
		  case "dragdrop_ranking":
            return (
			  <DragAndDropRanking
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          case "two-list":
            return (
              <DragAndDropTwoList
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
		  case "multiple":
            return (
              <DragAndDropMultiple
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          case "two-list-grouped":
            return (
              <DragAndDropTwoListGrouped
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          case "qa-pair":
            return (
              <DragAndDropQAPair
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          default:
            return (
              <DragAndDrop
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
        }
      case "simple-choice":
        switch (subtype) {
          case "grouped-text":
            return (
              <SimpleChoiceGroupedText
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          case "selection-info":
            return <SimpleChoiceSelectionInfo exercise={exercise} />;
          default:
            return (
              <SimpleChoice
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
        }
      case "simple-choice-image":
        return (
          <SimpleChoiceImage
            key={id}
            exercise={exercise}
            exercise_id={id}
            save2={saveresloc}
            inkey={indexkey}
            datasav2={datasav}
          />
        );
      case "multi-choice":
        switch (subtype) {
          case "grouped-text":
            return (
              <MultiChoiceGroupedText
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          case "text-box":
            return (
              <MultiChoiceTextBox
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          default:
            return (
              <MultiChoice
                key={id}
                savers={true}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
              
            );
        }
      case "likert_scale":
          return (
          <LikertScale2
            key={id}
            savers={true}
            exercise={exercise}
            exercise_id={id}
            save2={saveresloc}
            inkey={indexkey}
            datasav2={datasav}
          />);
      case "timeline":
        return <Timeline exercise={exercise} />;
      case "image-hover":
        return <ImageHover exercise={exercise} />;
      case "self-writing":
        return (
          <SelfWriting
            key={id}
            exercise={exercise}
            exercise_id={id}
            save2={saveresloc}
            inkey={indexkey}
            datasav2={datasav}
          />
        );
      case "dropdown":
        switch (subtype) {
          case "with-image":
            return (
              <DropDownWithImage
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          case "groups":
            return (
            <DropDownGroups 
            key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />);
          case "with-text":
            return (
              <DropDownWithText
                key={id}
                exercise={exercise}
                exercise_id={id}
                save2={saveresloc}
                inkey={indexkey}
                datasav2={datasav}
              />
            );
          default:
            return "";
        }

      case "life-cycle":
        return (
          <LifeCycleContext.Consumer>
            {({onActivitiesChange}) => {
              return <LifeCycle
                      key={id}
                      exercise={exercise}
                      exercise_id={id}
                      save2={saveresloc}
                      inkey={indexkey}
                      datasav2={datasav}
                      onActivitiesChange={(arr1,arr2) => onActivitiesChange(exercise.id,arr1,arr2)}
                    />
            } 
            }
          </LifeCycleContext.Consumer>
        );
      case "life-cycle-extension":
        return (
        <LifeCycleContext.Consumer>
            { ({getPropertyByLifeCycleID}) => {
                return (
                  <LifeCycleExtension
                  key={id}
                  exercise_id={id}
                  activities={getPropertyByLifeCycleID(exercise.dependsOn,'activities')}
                  impacts={getPropertyByLifeCycleID(exercise.dependsOn,'impacts')}
                />
                )
              }
            }
        </LifeCycleContext.Consumer>);
      case "extra-sdg":
        return (
          <ExtraSDG
            key={id}
            exercise={exercise}
            exercise_id={id}
            save2={saveresloc}
            inkey={indexkey}
            datasav2={datasav}
          />
        );
      /*return <ExtraSDG exercise={exercise}/>;*/
      case "without-one":
        const { dimensions } = exercise;
        return <WithoutOne dimensions={dimensions} alldata={alldata} />;
      default:
        return "";
    }
  }
 
  render() {
    const {
      classes,
      children,
      title,
      exercise,
      id,
      background_color,
      saveresloc,
      indexk,
      datasav,
      alldata,
      type,
      subtype,
	  isLastSection,
    showcard,
	isFeedback,
    openSection,
	smoothtrans,
      t
    } = this.props;
    let color = (background_color!==undefined && background_color!=="") ? {backgroundColor:"#"+background_color}:{};
    let stylePaddingBody = (showcard) ? {padding: "0 30px 30px 30px"}:{padding: "0 30px"};
    console.log(datasav)
    return (
      <div className={classes.root}>
        <Container className={classes.container}>
          <Card className={classes.cardExercise} style={color}>
            {/* <CardHeader className={classes.cardHeader}>
              
            </CardHeader> */}
            <CardBody 
						style={ (this.props.isMobile) ? {padding: "0 0 0 30px"}:stylePaddingBody}		>
              <span activity_type={type+" "+subtype}></span>

              
			  <GridContainer justifyContent="center" 
					style={
						{
							alignItems: "center",
							justifyContent: "space-between",
							minHeight: "110px",
							flexWrap: (this.props.isMobile) ? "wrap" : "nowrap",
							flexDirection: (this.props.isMobile) ? "column" : "row",
							gap: (this.props.isMobile) ? "1rem" : undefined,
							margin: (this.props.isMobile) ? "20px 0" : "auto",
						}}
				>
				<GridItem style={{ width: "100%" }} spaceLeft={0}>
				<GridContainer 
						alignItems="center"
						justifyContent="space-between"
						style={this.props.isMobile ? { width: "100%", flexDirection: "row"}:{ width: "100%", flexDirection: "row", flexWrap: "nowrap" }}
					>
                  <GuideCardTitle style={{marginBottom:"0"}}>
				  	<GridContainer
							style={{
								alignItems:"center",
								flexDirection: "row",
								flexWrap: "nowrap",
								gap: "1rem",
								flexGrow: "1",
								width: "100%"
							}}
						>
                        <GridItem space={0} spaceNoPadding={true}>
                          <img
                            src={isFeedback ? (typeof datasav !== "undefined" ? activity : greyActivity ) : activitynodataicon}
                            className={classes.dotimage2}
                            width="80px"
                            style={{paddingRight:"20px"}}
                            alt='Information'
                          />
                        </GridItem>
                        <GridItem 
							md="auto"
							lg="auto"
							spaceLeft={0}
							style={{ flexGrow: "1", width: "100%", maxWidth: "100%" }}
						>
                          <span>{(isFeedback ? t('Feedback Activity'):t('Activity'))}: {title}</span>
                        </GridItem>
                      </GridContainer>
                    </GuideCardTitle>
					<GridItem xs={12} md={3} spaceLeft={0} 
									style={this.props.isMobile ? {cursor:"pointer",
									marginTop:`${showcard ? "20px":"10px"}`}:
									{cursor:"pointer"}}>
									<div className={`${classes.iconDownArrowDiv}`}
                                            style={(title=="") ? 
                                                {marginBottom: "12.8px",paddingTop:"7px",textAlign:"right",display:"flex"} :
                                                {paddingTop:"0",textAlign:`${this.props.isMobile ? "center":"right"}`}}
                                        >
									</div>
					</GridItem>
				</GridContainer>
				</GridItem>
				<img
						src={arrowdown}
						style={{
							transform: (showcard) ? "rotate(-180deg)": undefined,
							display: "block",
							margin: `${this.props.isMobile ? "0":"0 auto"}`,
							flexGrow: 0,
							marginLeft:`${this.props.isMobile ? "-30px":"0"}`
						}}
						alt={t("Go to next section")}
						title={t("Go to next section")}
						onClick={openSection}
						className={classes.iconDownArrow}
					/>
			</GridContainer>


              <Collapse in={showcard}
			  style={{margin:`${this.props.isMobile ? "10px 0 20px -20px":"auto"}`}}
			  addEndListener={() => {
				if (showcard) {
					console.log("Scrolling exercise "+this.props.stepn+" "+this.props.indexk);
					setTimeout(() => {smoothtrans.scrollIntoView({behavior: "smooth"})}, 100);
				}
			}} >
              <div style={{marginBottom:"20px"}}></div>
              {children}
              {this._renderExerciseType(
                exercise,
                saveresloc,
                indexk,
                datasav,
                alldata,
                id
              )}
			  	{/*!isLastSection && <div onClick={goNextSection} className={`${classes.iconDownArrowDiv} moveArrow`}>
						<img
							src={arrowdown}
							alt="Go to next section"
							title="Go to next section"
							
							className={classes.iconDownArrow}
						/>
              </div>*/}
        </Collapse>
            </CardBody>
          </Card>
        </Container>
      </div>
    );
  }
}
 
GuideExercise.defaultProps = {
  children: <p>Here comes the content for this activity</p>,
  title: "Activity",
};
 
export default withTranslation()(withMyHook(withStyles(styles)(GuideExercise)));
 

